import React, { useContext } from "react"

type CompanyContextValues = {
  companyId: number
}

const CompanyContext = React.createContext<CompanyContextValues>(null)
export const useCompanyContext = (): CompanyContextValues => useContext(CompanyContext)

type CompanyContextProviderProps = {
  children: React.ReactNode
  companyId: number
}

export function CompanyContextProvider({ children, companyId }: CompanyContextProviderProps): JSX.Element {
  return (
    <CompanyContext.Provider
      value={{
        companyId
      }}
    >
      {children}
    </CompanyContext.Provider>
  )
}
